import { Trans } from 'react-i18next';
import React, { memo } from 'react';

import { itemTotalPrice, Price, usePriceFormat } from '@vmos2/price';
import { interpolate } from '@vmos2/core';
import { getFeeItem } from './getFeeItem';
import { Item } from './types';

type Props = {
	Component: React.Component;
	isTakeAway: boolean;
	items: Item[]
}

export const FeeInfo = memo(({ items, isTakeAway, Component, ...props }: Props) => {
	const format = usePriceFormat();

	const feeItem = getFeeItem(items, isTakeAway);
	const feePrice = feeItem ? itemTotalPrice(feeItem, isTakeAway) : 0;

	if (!feePrice) return null;
	const productCardNote = feeItem.disclaimers?.find(disclaimer => disclaimer.type === 'product_card_note');
	let feeDisclaimer = productCardNote ? interpolate(productCardNote.text, { price: format(feePrice) }) : undefined;
	if (feeItem.feeInfo.type) {
		feeDisclaimer = (
			<Trans
				ns="bundles.feeDisclaimers"
				i18nKey={feeItem.feeInfo.type}
				context={feeItem.feeInfo.includeInBasePrice ? 'inclusive' : 'exclusive'}
				values={{ price: feePrice }}
				components={[<Price />]}
			/>
		);
	}
	return feeDisclaimer ?
		<Component {...props}>
			{feeDisclaimer}
		</Component> :
		null;
});
